export default __webpack_public_path__ + "static/media/screen4.b95d88d3.jpg";